module.exports = __webpack_public_path__ + "static/media/close-button.6a36c30a.png";